module.exports = __webpack_public_path__ + "img/fecha.7423f312.svg";